import breakpoints from 'scripts/constants/breakpoints'

const MOBILE_PREFIX = 'm_'

const isMobile = (width = window.innerWidth) => width <= breakpoints.sm

export const event = ({
  eventCategory,
  eventAction,
  eventLabel,
  eventValue
}) => {
  if (isMobile()) {
    eventCategory = `${MOBILE_PREFIX}${eventCategory}`
  }

  if (window.ga) {
    window.ga(
      'send',
      'event',
      eventCategory,
      eventAction,
      eventLabel,
      eventValue
    )
  }
}

export default event
